<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  id: {
    type: String,
    required: true
  },
  placeholder: {
    type: String,
    default: ''
  },
  required: {
    type: Boolean,
    default: false
  },
  rows: {
    type: Number,
    default: 4
  },
  icon: {
    type: String,
    default: 'message'
  }
});

const emit = defineEmits(['update:modelValue']);

const updateValue = (event) => {
  emit('update:modelValue', event.target.value);
};
</script>

<template>
  <div class="relative">
    <div class="absolute inset-y-0 left-0 pl-3 pt-3 flex items-start pointer-events-none">
      <font-awesome-icon :icon="['fas', icon]" class="h-5 w-5 text-emerald-500" />
    </div>
    <div class="absolute top-0.5 left-10 flex items-center pt-3 pointer-events-none">
      <div class="h-4 w-px bg-black/30"></div>
    </div>
    <textarea
      :id="id"
      :value="modelValue"
      @input="updateValue"
      :required="required"
      :rows="rows"
      :placeholder="placeholder"
      class="block w-full rounded-md border-zinc-300 shadow-sm focus:outline-lime-400 sm:text-sm px-4 py-3 pl-12 bg-white"
    ></textarea>
  </div>
</template>
